import Config from '@config';
import {
  FiltersGrid,
  Pagination,
  infiniteQueryOptions,
  normalizeInfiniteQueryData,
} from '@gasbi/shared/index';
import { createApi } from '@reduxjs/toolkit/query/react';
import { useSelector } from 'react-redux';

import { cachedItemByIdSelector } from '@/features/utils';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

import { AccountPayment, AccountPaymentListItem } from './types';

export const accountPaymentsApi = createApi({
  reducerPath: 'accountPaymentsApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/account-payments',
  }),
  tagTypes: ['AccountPayments', 'AccountPayment'],
  endpoints: builder => ({
    getAccountPaymentsI: builder.infiniteQuery<
      AccountPaymentListItem[],
      FiltersGrid | void,
      Pagination
    >({
      infiniteQueryOptions,
      query: ({ queryArg, pageParam }) => ({
        url: '',
        params: { ...queryArg, ...pageParam },
      }),
      providesTags: ['AccountPayments'],
    }),
    getAccountPaymentById: builder.query<AccountPayment, string>({
      query: paymentId => ({
        url: `/${paymentId}`,
      }),
      providesTags: (_, __, paymentId) => [
        { type: 'AccountPayment', id: paymentId },
      ],
    }),
  }),
});

export const useGetAccountPaymentsInfiniteQuery = normalizeInfiniteQueryData(
  accountPaymentsApi.useGetAccountPaymentsIInfiniteQuery,
);

const getCachedAccountPaymentByIdSelector = cachedItemByIdSelector(
  'accountPaymentsApi',
  'getAccountPaymentsI',
);

export const useGetCachedAccountPaymentByIdSelector = (id: string) =>
  useSelector(getCachedAccountPaymentByIdSelector(id));

export const { useGetAccountPaymentByIdQuery } = accountPaymentsApi;
